// ─────────────────────────────────────────────────────────────────────────────
// EmailJS Configuration  –  this file is gitignored; fill in your credentials.
//
// How to set up:
//   1. Create a free account at https://www.emailjs.com
//   2. Add an Email Service (Gmail, Outlook, etc.) → copy the Service ID
//   3. Create TWO email templates (see notes below) → copy their Template IDs
//   4. Go to Account → API Keys → copy your Public Key
//
// ── Template 1: NOTIFICATION (to main@horizon-rcm.com) ──────────────────────
//   Subject : New Consultation Request – Horizon RCM Website
//   To email: main@horizon-rcm.com   (set this as a fixed "To Email" in EmailJS
//              OR pass it as {{to_email}} with value "main@horizon-rcm.com")
//   Body    : plain text only — no HTML styling (HTML mode OFF, or body is just):
//
//   {{message}}
//
//   The code sends a plain-text {{message}} for all internal notifications.
//
// ── Template 2: CONFIRMATION (to the lead) ──────────────────────────────────
//   Subject : {{subject}}                 ← passed as "Thank You for Reaching Out – Horizon RCM"
//   To email: {{to_email}}
//   Body    : {{{html_message}}}          ← triple braces = raw HTML passthrough
//   (Enable "Allow HTML" / set Content-Type to text/html in EmailJS settings)
//   NOTE: The code now builds a full branded HTML email and passes it as
//         html_message. The template body should contain only {{{html_message}}}.
// ─────────────────────────────────────────────────────────────────────────────

export const emailjsConfig = {
  serviceId: 'service_p22fc38',                   // 'service_xxxxxxx'
  notificationTemplateId: 'template_8nxnnxz',      // 'template_xxxxxxx'  — sends alert to main@horizon-rcm.com
  confirmationTemplateId: 'template_f3s3j51',      // 'template_xxxxxxx'  — sends thank-you HTML to the lead
  publicKey: 'qjmg_Wvp2JwDzlubp',                   // your EmailJS public key
};

// Emails that skip the styled lead confirmation (yours + any test/team addresses).
export const preRegisteredEmails = ['main@horizon-rcm.com'];

export function isPreRegisteredEmail(email) {
  const normalized = email.trim().toLowerCase();
  return preRegisteredEmails.some(
    registered => registered.toLowerCase() === normalized
  );
}

export function isEmailjsConfigured() {
  return !!(
    emailjsConfig.serviceId &&
    emailjsConfig.notificationTemplateId &&
    emailjsConfig.publicKey
  );
}
